const url = process.env.REACT_APP_WEATHER_API_KEY;

const getWeatherInfo = async () => {
  if (!url) return undefined;
  const response = await fetch(url)
    .then((res) => res.text())
    .then((data) => {
      data = JSON.parse(data);
      const fiveDaysOutput = [];
      const currentDay = data.current;
      fiveDaysOutput.push({
        temp: currentDay.temp,
        weather: currentDay.weather[0].main,
      });
      data.daily.map((day) => {
        fiveDaysOutput.push({
          temp: day.temp.day,
          weather: day.weather[0].main,
        });
      });
      return fiveDaysOutput.slice(0, 5);
    })
    .catch((err) => {
      console.log(err);
      return undefined;
    });
  return response;
};

export default getWeatherInfo;
